import { render, staticRenderFns } from "./VerificationCollectionData.vue?vue&type=template&id=aebff01e&scoped=true&"
import script from "./VerificationCollectionData.vue?vue&type=script&lang=js&"
export * from "./VerificationCollectionData.vue?vue&type=script&lang=js&"
import style0 from "./VerificationCollectionData.vue?vue&type=style&index=0&id=aebff01e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aebff01e",
  null
  
)

export default component.exports